<template>
  <div>
    <DSelect :items="klassCalendars"
             :isLoading="isLoading"
             :itemsSelected="selectedKlasses"
             :multiple="false"
             :placeholder="i18n[locale]['search']"
             @add="add"
             @remove="remove"
             @update="setSelectedKasses">
    </DSelect>
  </div>
</template>

<script>
  import DSelect from './DSelect'
  import {mapGetters} from 'vuex'

  export default {
    components: {DSelect},
    props: {
      showTags: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: true
      },
      showCreateButton: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters([
        'klassCalendars'
      ])
    },
    data () {
      return {
        selectedKlasses: [],
        searchText: '',
        locale: 'da',
        i18n: {
          da: {
            search: 'Søg og vælg klasse'
          },
          en: {
            search: 'Search and choose class'
          },
          nb: {
            search: 'Søk og velg klasse'
          }
        }
      }
    },
    watch: {
      selectedUsers () {
        this.$emit('updated', this.selectedKlasses)
      }
    },
    methods: {
      add (item) {
        this.$emit('add', item)
      },
      remove (item) {
        this.$emit('remove', item)
      },
      setSelectedKasses (val) {
        this.selectedKlasses = val
      }
    },
    beforeMount () {
      this.locale = window.USER.language ? window.USER.language : 'da'
    }
  }
</script>

<style scoped>
  .bttn.bttn-inline {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// DSelectKlass.vue?791e3e08